<template>
  <div class="about section">
    <div class="container">
      <div class="row">
        <div class="col-md-6 col-sm-12">
          <img src="/img/about/img2.jpg" alt="" />
        </div>
        <div class="col-md-6 col-sm-12">
          <div class="about-content">
            <h2 class="" style="font-size: 24px;padding: 10px 0; text-transform: uppercase; position: relative;   ">
              <span style="border-bottom: 3px solid #FFA800">KIRA RH c'est nous !</span>
            </h2>
            <p>Moussa et Minata, deux chargés de recrutement qui collaborent au sein d'un prestigieux cabinet de recrutement à dimension internationale.</p>

            <h2 class="" style="font-size: 24px;padding: 10px 0; text-transform: uppercase; position: relative;   ">
              <span style="border-bottom: 3px solid #FFA800">
                Pourquoi une solution RH ?
              </span>
            </h2>
            <p>Conscients de l'évolution du marché de l'emploi et de la nécessité d'adopter une stratégie de recherche efficace pour décrocher un emploi, nous avons à coeur de partager notre expérience de recruteur !</p>

            <p>C'est ainsi que la solution Kira RH voit le jour, tout d'abord pour accompagner nos proches et amis dans leur recherche d'emploi à travers plusieurs actions : la rédaction de cv - la préparation d'entretien (téléphonique - visio et physique) - la création de réseau.</p>

            <p>Ensuite la solution KIRA RH se propose aux entreprises, pour vous accompagner dans l'identification et le recrutement de vos talents en mettant en place des processus de recrutement adaptés à vos besoins. En tant que solution simple et efficace qui fait la différence, Kira RH agit comme un pont et crée des liens entre les employeurs et les chercheurs d'emploi.</p>

            <p>Certifiés de l'école du recrutement de Paris, le recrutement est notre expertise. Notre vocation est de guider les nouvelles générations vers une meilleure orientation et un épanouissement professionnel à travers des stratégies et pédagogies inclusives. Nous plaçons l’humain au cœur de nos activités sans aucune distinction de race, ethnie, origine, religion etc.</p>

            <p>Axés sur les résultats, nous avons grandi en faisant grandir les autres (candidats et clients) avec humilité.</p>

            <p>Kira, ensemble faisons chemin !</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "JobCareer",
};
</script>

<style scoped></style>
